import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Modal } from 'antd-v4'
import { Tabs } from 'antd'
import { CustomersTab } from './CustomersTab'
import { PermissionNames } from '@getgreenline/homi-shared'
import { CreditBalanceTab } from './CreditBalanceTab'

const { TabPane } = Tabs

interface Props {
  isModalVisible: boolean
  closeModal: () => void
  loadCustomers: () => Promise<void>
}

interface InjectedProps {
  currentUserStore?: CurrentUserStore
  currentCompanyStore?: CurrentCompanyStore
}

export const CustomerImportExportModal: React.FC<Props & InjectedProps> = inject(
  'currentUserStore',
  'currentCompanyStore',
)(
  observer(
    ({ isModalVisible, closeModal, loadCustomers, currentUserStore, currentCompanyStore }) => {
      const canAdjustLoyaltyBalance = currentUserStore!.hasPermissionAtEntity(
        PermissionNames.CAN_ADJUST_LOYALTY_BALANCE,
        currentCompanyStore!.company!.id,
      )

      return (
        <Modal
          title='Import / Export'
          visible={isModalVisible}
          onCancel={closeModal}
          maskClosable={true}
          footer={null}
          width={600}
        >
          <Tabs defaultActiveKey='customers'>
            <TabPane tab='Customers' key='customers'>
              <CustomersTab isModalOpen={isModalVisible} loadCustomers={loadCustomers} />
            </TabPane>

            {canAdjustLoyaltyBalance && (
              <TabPane tab='Loyalty Balance' key='creditBalances'>
                <CreditBalanceTab isModalOpen={isModalVisible} loadCustomers={loadCustomers} />
              </TabPane>
            )}
          </Tabs>
        </Modal>
      )
    },
  ),
)
